import tippy from 'tippy.js';

tippy('[data-tooltip]', {
  animation: 'scale',
  arrow: true,
  theme: 'material',
  inertia: true,
});
